export default __webpack_public_path__ + "static/media/NIAS0510.34I-37914_-22191_0.f1938146.jpg";